import { useEffect, useState } from 'react';
import { contractorApi } from '../../utils/installerApi';
import { toFa } from '../../utils/faFormat';

const FILE_MIMES = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', eml: 'message/rfc822', msg: 'application/vnd.ms-outlook', txt: 'text/plain' };
const DOCUMENT_KINDS = { permit: 'مجوز حفاری', rf_plan: 'نقشه RF', approval_email: 'ایمیل تایید', otdr: 'آزمون OTDR', other: 'سایر' };
export function DistributionControl({ token, job, onChanged, onError }) {
  const [candidates, setCandidates] = useState([]);
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    setCandidates([]); setSelected('');
    contractorApi.candidates(token, job.id).then((r) => { if (live) setCandidates(r.installers || []); })
      .catch((e) => { if (live) onError(e.message); });
    return () => { live = false; };
  }, [token, job.id, onError]);
  const distribute = async () => {
    setBusy(true);
    try { await contractorApi.distribute(token, job.id, selected); await onChanged(); }
    catch (e) { onError(e.message); }
    finally { setBusy(false); }
  };
  return <div className="cdash-addrow">
    <select className="inst-input" aria-label="نیروی دریافت‌کننده" value={selected} onChange={(e) => setSelected(e.target.value)} disabled={busy}>
      <option value="">انتخاب نیروی مجاز</option>
      {candidates.map((i) => <option key={i.id} value={i.id}>{i.full_name}</option>)}
    </select>
    <button className="inst-btn inst-btn-sm" disabled={busy || !candidates.some((i) => i.id === selected)} onClick={distribute}>توزیع کار</button>
    {!candidates.length && <p className="inst-empty-hint">نیروی تاییدشده و مجاز برای اپراتور و نوع این کار در زیرمجموعه نیست.</p>}
  </div>;
}

function fileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('خواندن فایل ناموفق بود.'));
    reader.readAsDataURL(file);
  });
}
export function CompanyJobDocuments({ token, jobId }) {
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(null);
  const [kind, setKind] = useState('permit');
  const [validUntil, setValidUntil] = useState('');
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!open) return;
    let live = true;
    contractorApi.documents(token, jobId).then((r) => { if (live) setResult(r); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [token, jobId, open]);
  const upload = async () => {
    if (!file) return;
    setBusy(true); setError(null);
    try {
      const mime = FILE_MIMES[file.name.split('.').pop().toLowerCase()];
      if (file.size > 20 * 1024 * 1024 || !mime) throw new Error('فایل PDF، تصویر، ایمیل یا متن تا ۲۰ مگابایت انتخاب کنید.');
      await contractorApi.uploadDocument(token, jobId, { kind, valid_until: validUntil || null, file_name: file.name, mime, data_base64: await fileBase64(file) });
      setFile(null);
      setResult(await contractorApi.documents(token, jobId));
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <div className="cdash-documents">
    <button className="inst-btn inst-btn-ghost inst-btn-sm" onClick={() => setOpen(!open)}>{open ? 'بستن مدارک' : 'مدارک کار'}</button>
    {open && <>
      {error && <p role="alert" className="inst-alert">{error}</p>}
      {!result ? <p>در حال بارگذاری...</p> : !result.available ? <p>بارگذاری مدارک هنوز فعال نیست.</p> : <>
        <p>مدارک پنل فقط توسط ناظر یا مدیر تایید می‌شوند و جایگزین عکس دوربین نیستند.</p>
        <ul className="cdash-list">{result.documents.map((d) => <li key={d.id}>
          {DOCUMENT_KINDS[d.kind] || d.kind}: {d.file_name} · {d.finalized_at === null ? 'بارگذاری تکمیل نشده' : d.decision === 'approved' ? 'تاییدشده' : d.decision === 'rejected' ? 'ردشده' : 'در انتظار بررسی'}
          {d.valid_until && <span> · اعتبار: {new Date(d.valid_until).toLocaleDateString('fa-IR')}</span>}
        </li>)}</ul>
        <label>نوع مدرک<select className="inst-input" value={kind} onChange={(e) => setKind(e.target.value)}>
          {Object.entries(DOCUMENT_KINDS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
        </select></label>
        <label>اعتبار تا (اختیاری)<input className="inst-input" type="date" value={validUntil} onChange={(e) => setValidUntil(e.target.value)} /></label>
        <label>فایل مدرک<input type="file" accept=".pdf,.jpg,.jpeg,.png,.eml,.msg,.txt" onChange={(e) => setFile(e.target.files?.[0] || null)} /></label>
        {file && <p>{file.name} ({toFa(Math.ceil(file.size / 1024))} کیلوبایت)</p>}
        <button className="inst-btn inst-btn-sm" disabled={busy || !file} onClick={upload}>{busy ? 'در حال بارگذاری...' : 'بارگذاری مدرک'}</button>
      </>}
    </>}
  </div>;
}
